import React from "react";
import { PropTypes } from "prop-types";
import { Banner, Button } from "@kui/foundations-react";
import "../../styles/RegCard.css";

// Validation / error messages for the registration form, shown as a KUI banner at the top of the page.
const MessageCenter = props => {
  const messages = Array.isArray(props.messages) ? props.messages : [props.messages];

  return (
    <div className="regMessages">
      <Banner status={props.status} role="alert">
        {messages.length === 1 ? (
          messages[0]
        ) : (
          <ul className="regMessagesList">
            {messages.map((m, i) => (
              <li key={i}>{m}</li>
            ))}
          </ul>
        )}
      </Banner>
      {props.showUserInput && (
        <div className="regActions regMessagesActions">
          <Button kind="secondary" color="neutral" onClick={props.onNoClick}>
            No
          </Button>
          <Button kind="primary" color="brand" onClick={props.onYesClick}>
            Yes
          </Button>
        </div>
      )}
    </div>
  );
};

MessageCenter.propTypes = {
  messages: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  status: PropTypes.oneOf(["error", "warning", "success", "info"]),
  showUserInput: PropTypes.bool,
  onYesClick: PropTypes.func,
  onNoClick: PropTypes.func
};

MessageCenter.defaultProps = {
  status: "error"
};
export default MessageCenter;
